module.exports = __webpack_public_path__ + "img/4.ce1ad96e.jpg";